export default __webpack_public_path__ + "static/media/cus3.7fe9d1e1.svg";